export default "__VITE_ASSET__BlWDZK2R__"